import { Button, FormControlLabel, FormGroup, Switch } from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import {
  baseUrl,
  checkInFromHotel,
  getCashierData,
  getCurrentUser,
  getEmptyRoomNumber,
  getRoomInformationData,
  getRoomRatePlan,
  getRoomType,
} from "../../api-config/config";
import {
  formateDateInApiSupport,
  isEqualOrAfter,
} from "../../utils/formatTime";
import moment from "moment";
import { insertPaymentData } from "../../api-config/payment.api";
import {
  getCorporateData,
  getTravelAgentData,
} from "../../api-config/corporate.api";
import { getRoomPrice } from "../../utils/utilFuncForEditReservation";
import DateRangeComponent from "../DateRangePicker";
import { calNoOfNights } from "../../utils/formatNumber";
import "./BookingForm.css";

const getTaxRateForBase = (basePrice: number, nights: number, roomCount = 1) => {
  const pricePerRoomPerNight =
    basePrice / (Math.max(nights, 1) * Math.max(roomCount, 1));
  return pricePerRoomPerNight > 7500 ? 18 : 5;
};

const ReservationFrom = (props: any) => {
  const {
    calendarInfo,
    selectedRoomInfo,
    handleClose,
    onFormSubmitted,
    roomTypeList1,
    groupIndBtn,
    resourceMap,
    bookedRooms,
  } = props;

  const currentDate = new Date();
  const nextDayDate = new Date(currentDate);
  nextDayDate.setDate(currentDate.getDate() + 1);

  const [range, setRange] = useState({
    startDate: new Date(calendarInfo.startStr),
    endDate: new Date(calendarInfo.endStr),
    key: "selection",
  });
  const [indRatePlan, setIndRatePlan] = useState(0);

  const defaultCalculatedPrice = {
    total_sale_price: selectedRoomInfo.price * calendarInfo?.noOfNights,
    taxInfo: {},
    total_tax:
      selectedRoomInfo.price +
        (getRoomPrice(selectedRoomInfo?.room_type_id, roomTypeList1)
          .service_charge /
          100) *
          selectedRoomInfo.price <=
      7500
        ? selectedRoomInfo.price +
          (getRoomPrice(selectedRoomInfo?.room_type_id, roomTypeList1)
            .service_charge /
            100) *
            selectedRoomInfo.price *
            0.05
        : selectedRoomInfo.price +
          (getRoomPrice(selectedRoomInfo?.room_type_id, roomTypeList1)
            .service_charge /
            100) *
            selectedRoomInfo.price *
            0.18,
    total_price_with_tax:
      selectedRoomInfo.price +
        (getRoomPrice(selectedRoomInfo?.room_type_id, roomTypeList1)
          .service_charge /
          100) *
          selectedRoomInfo.price <=
      7500
        ? selectedRoomInfo.price +
          (getRoomPrice(selectedRoomInfo?.room_type_id, roomTypeList1)
            .service_charge /
            100) *
            selectedRoomInfo.price *
            1.05
        : selectedRoomInfo.price +
          (getRoomPrice(selectedRoomInfo?.room_type_id, roomTypeList1)
            .service_charge /
            100) *
            selectedRoomInfo.price *
            1.18,
    discountAmount: 0,
    room_service_charge:
      (getRoomPrice(selectedRoomInfo?.room_type_id, roomTypeList1)
        .service_charge /
        100) *
      selectedRoomInfo.price,
    service_charge_in_percentage: getRoomPrice(
      selectedRoomInfo?.room_type_id,
      roomTypeList1,
    ).service_charge,
    total_without_tax:
      selectedRoomInfo.price +
      (getRoomPrice(selectedRoomInfo?.room_type_id, roomTypeList1)
        .service_charge /
        100) *
        selectedRoomInfo.price,
    total_without_service: selectedRoomInfo.price,
  };

  const [discountError, setDiscountError] = useState("");
  const [calculatedPrice, setCalcualtedPrice] = useState(
    defaultCalculatedPrice,
  );
  const [originalPrice, setOriginalPrice] = useState(
    selectedRoomInfo.price * calendarInfo.noOfNights || 0,
  );
  const [discountValue, setDiscountValue] = useState(0);
  const [discountType, setDiscountType] = useState("Percentage");
  const [mode, setMode] = useState("");
  const [marketSegment, setMarketSegment] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [roomRatePlan, setRoomRatePlan] = useState([]);
  const [noOfAdult, setNoOfAdult] = useState(
    selectedRoomInfo?.base_occupancy || 1,
  );
  const [isReserveButtonClicked, setIsReserveButtonClicked] = useState(false);
  const [roomInfoBasedOnAdult, setRoomInfoBasedOnAdult] = useState({} as any);
  const [noOfChild, setNoOfChild] = useState(0);
  const [rateType, setRateType] = useState("");
  const [selectedRoomPlan, setSelectedRoomPlan] = useState({} as any);
  const [noOfRoomsAvl, setNoOfRoomsAvl] = useState(1);
  const [noOfRoomsSelected, setNoOfRoomsSelected] = useState(1);
  const [data, setData] = useState([]);
  const loggedUser = getCurrentUser();
  const [checked, setChecked] = useState(true);
  const [useReversePrice, setUseReversePrice] = useState(false);
  const [roomList, setRoomList] = useState([] as any);
  const [emptyRoom, setEmptyRoom] = useState([] as any);
  const [selectedRoom, setSelectedRoom] = useState({
    id: selectedRoomInfo?.id || "",
    room_name: selectedRoomInfo?.room_name || "",
  } as any);
  const [roomTypeList, setRoomTypeList] = useState([] as any);
  const [selectedRoomType, setSelectedRoomType] = useState({
    id: selectedRoomInfo?.room_type_id || "",
  } as any);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log(event.target.checked, "this is checked");
    setChecked(event.target.checked);
  };

  const getRoomTypeList = (hotel_code: number, floor_id: number) => {
    return getRoomType(hotel_code, floor_id).then(
      (res: any) => {
        if (res?.status_message === "success") {
          const roomTypeArray = [] as any;
          res.data?.forEach((roomType: any) => {
            const obj = {
              id: roomType.id,
              room_type_name: roomType.room_type_name,
              rooms: roomType.rooms,
              price: roomType.price,
            };
            roomTypeArray.push(obj);
          });
          setRoomTypeList([...roomTypeArray]);
        } else {
          console.log(res.message);
        }
      },
      (error: any) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        console.log("error", resMessage);
      },
    );
  };

  function onRoomTypeSelected(id: any) {
    roomTypeList?.forEach((roomType: any) => {
      if (Number(id) === roomType.id) {
        setSelectedRoomType(roomType);
        setRoomList([...roomType.rooms]);

        setRateType("");
        setSelectedRoomPlan({});
        if (typeof window !== "undefined") {
          const rateTypeField: any =
            document.querySelector('[name="rateType"]');
          if (rateTypeField) rateTypeField.value = "";
        }

        const payload = {
          hotel_code: loggedUser?.hotel_code,
          start_date: formateDateInApiSupport(range.startDate),
          end_date: formateDateInApiSupport(range.endDate),
          room_info: [
            {
              number_of_adults: +noOfAdult,
              number_of_children: +noOfChild,
              number_of_children_0_6: 0,
              number_of_children_6_12: 0,
            },
          ],
        };
        getRoomInformationData(payload).then((roomInformationData: any) => {
          setRoomInfoBasedOnAdult(roomInformationData.data);
          roomInformationData?.data?.rooms?.forEach((singleRoomInfo: any) => {
            if (Number(id) === singleRoomInfo?.room_type_id) {
              setOriginalPrice(singleRoomInfo?.room_price?.total_price);
            }
          });
        });
      }
    });
  }

  function onRoomSelected(id: any) {
    const selectedRoomObj = roomList.find(
      (room: any) => room.id === Number(id),
    );
    if (selectedRoomObj) {
      setSelectedRoom(selectedRoomObj);
    }
  }

  const fetchSegmentData = (e: any) => {
    setMarketSegment(e.target.value);
    switch (e.target.value) {
      case "Corporate":
        return getCorporateData(loggedUser?.hotel_code, 0).then((res) =>
          setData(res.data),
        );
      case "Travel Agent":
        return getTravelAgentData(loggedUser?.hotel_code, 0).then((res) =>
          setData(res.data),
        );
      default:
        return;
    }
  };

  const defaultValues = {
    adult: selectedRoomInfo?.base_occupancy,
    child: 0,
    partialPayment: 0,
    email: "",
    price: "",
    mobNumber: "",
    market_segment: "",
    travel_agent_id: undefined,
    corporate_id: undefined,
    discountMethod: "",
    discountValue: 0,
    firstName: "",
    lastName: "",
    firstName2: "",
    firstName3: "",
    lastName2: "",
    lastName3: "",
    rooms: 1,
    rateType: "",
    payment_mode: "",
    coveredServices: "",
    roomType: selectedRoomInfo?.room_type_id || "",
    room: selectedRoomInfo?.id || "",
  };

  const formValidation = Yup.object().shape({
    firstName: Yup.string().required("Please enter first name"),
    mobNumber: Yup.string()
      .required("Please enter your mobile number")
      .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits"),
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Please enter your email"),
    rateType: Yup.string().required("Please select a Rate Type"),
    roomType: Yup.string().required("Please select a room type"),
    room: Yup.string().required("Please select a room"),
  });

  function handleReserveSubmit(e: any) {
    setIsReserveButtonClicked(true);
  }

  const handleSubmit = (formData: any) => {
    formData.adult = noOfAdult;
    formData.child = noOfChild;
    formData.price = calculatedPrice.total_price_with_tax;

    console.log(formData, "final body");
    const other_members = [];
    if (noOfAdult >= 2) {
      if (formData.firstName2) {
        other_members.push({
          first_name: formData.firstName2,
          last_name: formData.lastName2,
        });
      }
      if (formData.firstName3) {
        other_members.push({
          first_name: formData.firstName3,
          last_name: formData.lastName3,
        });
      }
    }

    console.log("before body testing temp========");

    const body = {
      hotel_code: selectedRoomInfo?.hotel_code,
      from_date: formateDateInApiSupport(range.startDate),
      to_date: formateDateInApiSupport(range.endDate),
      total_sale_amount: calculatedPrice.total_sale_price,
      total_without_tax: calculatedPrice.total_without_tax,
      tax_amount: checked ? calculatedPrice.total_tax : 0,
      total_services_amount: calculatedPrice.room_service_charge,
      service_charge: calculatedPrice.service_charge_in_percentage,
      gross_amount: formData.price,
      discount_value: formData.discountAmount,
      travel_agent_id: formData.travel_agent_id,
      corporate_id: formData.corporate_id,
      discount_type: formData.discountMethod,
      discount_amount: calculatedPrice?.discountAmount || 0,
      minimum_advance: 0,
      payment_mode: paymentMode,
      no_of_nights: calNoOfNights(range.startDate, range.endDate),
      paid_amount: formData.partialPayment,
      balance_amount: formData.price - formData.partialPayment,
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      market_segment: formData.market_segment,
      address: "",
      phone_number: formData.mobNumber,
      mobile_number: formData.mobNumber,
      country: "India",
      booking_status: isReserveButtonClicked ? "pending" : "check_in",
      check_in_time: isReserveButtonClicked
        ? null
        : moment().format("YYYY-MM-DD HH:mm:ss"),
      room_type_id: selectedRoomType.id,
      rate_plan_id: selectedRoomPlan.id,
      rate_plan_amount: selectedRoomPlan.rate_amount || 0,
      booking_type: groupIndBtn.btnType,
      no_of_rooms: noOfRoomsSelected,
      covered_services: formData.coveredServices,

      room_assinged_adult_info: [
        {
          no_of_adults: formData.adult,
          no_of_child: formData.child || 0,
          no_of_rooms: +formData.rooms,
          room_id: selectedRoom.id,
        },
      ],
      room_booking: [
        {
          room_id: selectedRoom.id,
          no_of_pax: Number(formData.adult + formData.child) || formData.adult,
          no_of_adults: formData.adult,
          no_of_children: formData.child || 0,
          no_of_rooms: +formData.rooms,
          total_sale_amount: calculatedPrice.total_sale_price,
          discount_amount: calculatedPrice?.discountAmount || 0,
          coupon_amount: 0,
          total_without_tax: calculatedPrice.total_without_tax,
          tax_amount: checked ? calculatedPrice.total_tax : 0,
          gross_amount: formData.price,
        },
      ],
      booking_service: [],
      other_members,
    };

    setIsReserveButtonClicked(false);
    console.log("calling reserve button");

    checkInFromHotel(body).then((response: any) => {
      getCashierData({
        hotel_code: loggedUser?.hotel_code,
        date: moment().format("YYYY-MM-DD"),
      }).then((res: any) => {
        const body = {
          booking_id: response.data?.[0],
          paid_amount: formData.partialPayment,
          gross_amount: formData.price,
        } as any;
        if (formData.partialPayment && mode) {
          if (mode === "UPI") {
            body.upi = formData.partialPayment;
          } else if (mode === "CASH") {
            body.cash = formData.partialPayment;
          } else if (mode === "CARD") {
            body.card = formData.partialPayment;
          } else if (mode === "ONLINE") {
            body.online = formData.partialPayment;
          }
          body.comment = `Recevied payment from ${
            formData.firstName + " " + formData.lastName
          } ${
            calendarInfo?.resource?._resource?.title
          } booking status ${(body.booking_status = isReserveButtonClicked
            ? "Reserved"
            : "Check in")}`;
          const cashierBal = res.data[res.data.length - 1];

          body.available_balance = cashierBal.available_balance;

          insertPaymentData(body);
        }
      });

      if (response?.data?.room_booking?.length > 0) {
        const payload = {
          first_name: response?.data?.first_name,
          checkinDate: response.data?.from_date,
          checkoutDate: response.data?.to_date,
          roomType: response?.data?.room_booking[0]?.room_title,
          roomNo: response.data?.room_booking[0]?.room_id,
          totalPrice: response.data?.gross_amount,
          receiptLink: `${baseUrl}/booking_pdf_pms?booking_id=${response.data.booking_id}&customer_id=${response.data.customer_id}`,
          from_name: response.data?.hotel_name,
          reply_to: "booking@ratebotai.com",
          to_email: response.data?.email,
        };
      }
      console.log(response);
      onFormSubmitted(response);
    });
  };

  const getServiceChargePercent = () => {
    const matchedRoom = roomInfoBasedOnAdult?.rooms?.find(
      (roomInfo: any) =>
        (selectedRoomType.id || selectedRoomInfo?.room_type_id) ===
        roomInfo.room_type_id,
    );
    if (matchedRoom?.service_charge != null) {
      return matchedRoom.service_charge;
    }
    return (
      getRoomPrice(
        selectedRoomType.id || selectedRoomInfo?.room_type_id,
        roomTypeList1,
      ).service_charge || 0
    );
  };

  const applyReversePriceCalc = (finalPriceInput: number) => {
    const finalPrice = Math.max(0, Number(finalPriceInput) || 0);
    const nights = calNoOfNights(range.startDate, range.endDate);
    const roomCount = noOfRoomsSelected || 1;
    const serviceChargePercent = getServiceChargePercent();

    if (finalPrice === 0) {
      setOriginalPrice(0);
      setCalcualtedPrice((prev: any) => ({
        ...prev,
        total_sale_price: 0,
        total_without_service: 0,
        total_without_tax: 0,
        total_tax: 0,
        total_price_with_tax: 0,
        room_service_charge: 0,
        service_charge_in_percentage: serviceChargePercent,
      }));
      return;
    }

    let priceWithService = finalPrice / 1.05;
    if (getTaxRateForBase(priceWithService, nights, roomCount) === 18) {
      priceWithService = finalPrice / 1.18;
    }

    const tax = finalPrice - priceWithService;
    const baseSalePrice = priceWithService / (1 + serviceChargePercent / 100);
    const roomServiceCharge = priceWithService - baseSalePrice;

    setOriginalPrice(baseSalePrice);
    setCalcualtedPrice((prev: any) => ({
      ...prev,
      total_sale_price: baseSalePrice,
      total_without_service: baseSalePrice,
      total_without_tax: priceWithService,
      total_tax: tax,
      total_price_with_tax: finalPrice,
      room_service_charge: roomServiceCharge,
      service_charge_in_percentage: serviceChargePercent,
      discountAmount: 0,
    }));
  };

  const handleReversePriceToggle = (enabled: boolean) => {
    setUseReversePrice(enabled);
    if (enabled) {
      applyReversePriceCalc(calculatedPrice.total_price_with_tax);
    } else {
      findRoomInfoAndSetPrice(
        roomInfoBasedOnAdult,
        {
          discountMethod: discountType,
          discountValue: Number(discountValue),
        },
        { skipReverseGuard: true },
      );
    }
  };

  function findRoomInfoAndSetPrice(
    data: any,
    discountObj?: any,
    options?: { skipReverseGuard?: boolean },
  ) {
    if (useReversePrice && !options?.skipReverseGuard) {
      return;
    }

    console.log(data, discountObj, "start");

    const priceObj = {} as any;
    let price: any = originalPrice;
    if (!data.occupancy_flag) {
      onNoOfAdultlChange(noOfAdult);
    } else {
      data?.rooms?.forEach((roomInfo: any, key: any) => {
        console.log(roomInfo);
        if (selectedRoomType.id === roomInfo.room_type_id) {
          price = originalPrice;
          priceObj.total_sale_price = price;
          priceObj.service_charge_in_percentage = roomInfo.service_charge;

          let discountAmount = 0;
          if (
            discountObj &&
            discountObj.discountMethod &&
            discountObj.discountValue
          ) {
            if (discountObj.discountMethod === "Percentage") {
              const limitedDiscountValuePercentage = Math.min(
                discountObj.discountValue,
                100,
              );
              discountAmount = (price * limitedDiscountValuePercentage) / 100;
              price = price - discountAmount;
              priceObj.discountAmount = discountAmount;
              priceObj.total_without_service = price;
            } else if (discountObj.discountMethod === "Amount") {
              const limitedDiscountValueAmount = Math.min(
                discountObj.discountValue,
                price,
              );
              discountAmount = limitedDiscountValueAmount;
              priceObj.discountAmount = discountObj.discountValue;
              priceObj.total_without_service = price;

              const room_service_charge = roomInfo.service_charge
                ? (price * roomInfo.service_charge) / 100
                : 0;
              const priceWithService = price + room_service_charge;
              let tax = 0;
              if (priceWithService / calendarInfo.noOfNights > 7500) {
                tax = (priceWithService * 18) / 100;
              } else {
                tax = (priceWithService * 5) / 100;
              }
              const finalPriceWithTax =
                priceWithService + tax - discountObj.discountValue;
              const finalPriceWithoutTax =
                priceWithService - discountObj.discountValue;

              priceObj.room_service_charge = room_service_charge;
              priceObj.total_without_tax = Math.max(finalPriceWithoutTax, 0);
              priceObj.total_tax = tax;
              priceObj.total_price_with_tax = Math.max(finalPriceWithTax, 0);
              priceObj.total_without_service = Math.max(
                finalPriceWithoutTax,
                0,
              );

              setCalcualtedPrice({ ...calculatedPrice, ...priceObj });
              return;
            }
          } else {
            priceObj.discountAmount = discountAmount;
            priceObj.total_without_service = price;
          }
          const room_service_charge = roomInfo.service_charge
            ? (price * roomInfo.service_charge) / 100
            : 0;
          price = price + room_service_charge;
          priceObj.room_service_charge = room_service_charge;
          priceObj.total_without_tax = price;

          if (price / calendarInfo.noOfNights > 7500) {
            let tax = 0;
            tax = (price * 18) / 100;
            priceObj.total_tax = tax;
            price = price + tax;
            priceObj.total_price_with_tax = price;
          } else {
            let tax = 0;
            tax = (price * 5) / 100;
            priceObj.total_tax = tax;
            price = price + tax;
            priceObj.total_price_with_tax = price;
          }
          priceObj.total_price_with_tax = Math.max(
            priceObj.total_price_with_tax,
            0,
          );
          priceObj.total_without_tax = Math.max(priceObj.total_without_tax, 0);
        }
      });

      setCalcualtedPrice({ ...calculatedPrice, ...priceObj });
    }
  }

  function onSetRange(value: any) {
    if (moment(value.endDate).isBefore(value.startDate, "day")) {
      value.startDate = moment(value.endDate).toDate();
      value.endDate = moment(value.startDate).add(1, "days").toDate();
    }
    setRange(value);
  }

  const handleRoomChanged = (e: any) => {
    setNoOfRoomsSelected(+e.target.value);
  };

  useEffect(() => {
    getRoomTypeList(loggedUser?.hotel_code, 1);

    const body = {
      from_date: formateDateInApiSupport(range.startDate),
      to_date: formateDateInApiSupport(range.endDate),
      pms_hotel_code: loggedUser?.hotel_code,
      room_type_id: selectedRoomType.id || selectedRoomInfo.room_type_id,
    };

    getEmptyRoomNumber(body)
      .then((response: any) => {
        setEmptyRoom(response.data || []);
        setNoOfRoomsSelected(1);
        setNoOfRoomsAvl(response.data.length);
        setRoomList(response.data || []);

        if (response.data && response.data.length > 0) {
          if (selectedRoomInfo?.id) {
            const preSelectedRoom = response.data.find(
              (room: any) => room.id === selectedRoomInfo.id,
            );
            if (preSelectedRoom) {
              setSelectedRoom(preSelectedRoom);
            } else {
              setSelectedRoom({
                id: response.data[0].id,
                room_name: response.data[0].room_name,
              });
            }
          } else {
            setSelectedRoom({
              id: response.data[0].id,
              room_name: response.data[0].room_name,
            });
          }
        }
      })
      .catch((error: any) => {
        console.error("Error fetching data:", error);
      });
  }, [
    range.startDate,
    range.endDate,
    selectedRoomType.id,
    selectedRoomInfo?.room_type_id,
  ]);

  // useEffect(() => {
  //   const nights = calNoOfNights(range.startDate, range.endDate);
  //   const basePrice = getRoomPrice(selectedRoomType.id || selectedRoomInfo?.room_type_id, roomTypeList1).price;
  //   setOriginalPrice(basePrice * nights);
  //   findRoomInfoAndSetPrice(roomInfoBasedOnAdult, {
  //     discountMethod: discountType,
  //     discountValue: Number(discountValue),
  //   });
  // }, [range.startDate, range.endDate, selectedRoomType.id, selectedRoomInfo?.room_type_id]);

  useEffect(() => {
    const nights = calNoOfNights(range.startDate, range.endDate);

    const payload = {
      hotel_code: selectedRoomInfo?.hotel_code,
      start_date: formateDateInApiSupport(range.startDate),
      end_date: formateDateInApiSupport(range.endDate),
      room_info: [
        {
          number_of_adults: noOfAdult,
          number_of_children: noOfChild,
          number_of_children_0_6: 0,
          number_of_children_6_12: 0,
        },
      ],
    };

    getRoomInformationData(payload).then((roomInformationData: any) => {
      setRoomInfoBasedOnAdult(roomInformationData.data);

      if (useReversePrice) {
        applyReversePriceCalc(calculatedPrice.total_price_with_tax);
        return;
      }

      let baseRoomPrice = 0;

      roomInformationData?.data?.rooms?.forEach((singleRoomInfo: any) => {
        if (
          (selectedRoomType.id || selectedRoomInfo?.room_type_id) ===
          singleRoomInfo?.room_type_id
        ) {
          baseRoomPrice = singleRoomInfo?.room_price?.total_price || 0;
        }
      });

      // new calculation for final price according the duration of stay
      const rateAmount = selectedRoomPlan?.rate_amount || 0;
      const finalPrice = baseRoomPrice + rateAmount * noOfAdult * nights;

      console.log(
        "Date Range:",
        formateDateInApiSupport(range.startDate),
        "to",
        formateDateInApiSupport(range.endDate),
      );
      console.log("Nights:", nights);
      console.log("Base Room Price from API:", baseRoomPrice);
      console.log("Rate Amount:", rateAmount);
      console.log("Final Price:", finalPrice);

      setOriginalPrice(finalPrice);

      findRoomInfoAndSetPrice(roomInformationData.data, {
        discountMethod: discountType,
        discountValue: Number(discountValue),
      });
    });
  }, [
    range.startDate,
    range.endDate,
    selectedRoomType.id,
    selectedRoomInfo?.room_type_id,
    noOfAdult,
    noOfChild,
    selectedRoomPlan,
    useReversePrice,
  ]);

  // useEffect(() => {
  //   // Initialize room type list
  //   getRoomTypeList(loggedUser?.hotel_code, 1);

  //   // Get available rooms for selected room type
  //   const body = {
  //     from_date: formateDateInApiSupport(range.startDate),
  //     to_date: formateDateInApiSupport(range.endDate),
  //     pms_hotel_code: loggedUser?.hotel_code,
  //     room_type_id: selectedRoomType.id || selectedRoomInfo.room_type_id,
  //   };

  //   getEmptyRoomNumber(body)
  //     .then((response: any) => {
  //       setNoOfRoomsSelected(1);
  //       setNoOfRoomsAvl(response.data.length);
  //       setRoomList(response.data || []);

  //       // Fix: Properly set the selected room when room list loads
  //       if (response.data && response.data.length > 0) {
  //         // If there's a pre-selected room info, try to find it in the available rooms
  //         if (selectedRoomInfo?.id) {
  //           const preSelectedRoom = response.data.find((room: any) =>
  //             room.id === selectedRoomInfo.id
  //           );
  //           if (preSelectedRoom) {
  //             setSelectedRoom(preSelectedRoom);
  //           } else {
  //             // Fallback to first available room
  //             setSelectedRoom({ id: response.data[0].id, room_name: response.data[0].room_name });
  //           }
  //         } else {
  //           // Default to first available room
  //           setSelectedRoom({ id: response.data[0].id, room_name: response.data[0].room_name });
  //         }
  //       }
  //     })
  //     .catch((error: any) => {
  //       console.error("Error fetching data:", error);
  //     });

  //   setRateType("");
  //   setCalcualtedPrice((prev: any) => {
  //     return {
  //       ...prev,
  //       service_charge_in_percentage:
  //         +getRoomPrice(selectedRoomType.id || selectedRoomInfo?.room_type_id, roomTypeList1)
  //           .service_charge || 10,
  //     };
  //   });
  //   setOriginalPrice(
  //     getRoomPrice(selectedRoomType.id || selectedRoomInfo?.room_type_id, roomTypeList1).price *
  //       calNoOfNights(range.startDate, range.endDate)
  //   );
  // }, [range.startDate, range.endDate, selectedRoomType.id, selectedRoomInfo?.room_type_id]);

  useEffect(() => {
    getRoomRatePlan({
      hotel_code: selectedRoomInfo?.hotel_code,
      room_type_id: selectedRoomType.id || selectedRoomInfo?.room_type_id,
    }).then((response) => setRoomRatePlan(response?.data));
  }, [selectedRoomType.id]);

  useEffect(() => {
    if (useReversePrice) {
      return;
    }
    findRoomInfoAndSetPrice(roomInfoBasedOnAdult, {
      discountMethod: discountType,
      discountValue: Number(discountValue),
    });
  }, [originalPrice, discountValue, useReversePrice]);

  const handleOnchangePlan = (id: any) => {
    const match: any = roomRatePlan.find((plan: any) => plan.name === id);

    if (match) {
      const rateAmount = match.rate_amount;
      if (useReversePrice) {
        setSelectedRoomPlan(match);
        return;
      }
      roomInfoBasedOnAdult?.rooms?.forEach((singleRoomInfo: any) => {
        if (selectedRoomType.id === singleRoomInfo?.room_type_id) {
          const baseRoomPrice = singleRoomInfo?.room_price?.total_price || 0;
          setOriginalPrice(
            baseRoomPrice +
              rateAmount *
                noOfAdult *
                calNoOfNights(range.startDate, range.endDate),
          );
        }
      });
      setSelectedRoomPlan(match);
    }
  };

  function onNoOfAdultlChange(value: any, str: any = "") {
    // setRateType("");
    if (str === "child") {
      setNoOfChild(Number(value));
    } else {
      setNoOfAdult(Number(value));
    }

    // const payload = {
    //   hotel_code: selectedRoomInfo?.hotel_code,
    //   start_date: range.startDate,
    //   end_date: range.endDate,
    //   room_info: [
    //     {
    //       number_of_adults: str === "child" ? noOfAdult : value,
    //       number_of_children: str === "child" ? child : noOfChild,
    //       number_of_children_0_6: 0,
    //       number_of_children_6_12: 0,
    //     },
    //   ],
    // };

    // getRoomInformationData(payload).then((roomInformationData: any) => {
    //   setRoomInfoBasedOnAdult(roomInformationData.data);

    //   let baseRoomPrice = 0;
    //   roomInformationData?.data?.rooms?.forEach((singleRoomInfo: any) => {
    //     if (selectedRoomType.id === singleRoomInfo?.room_type_id) {
    //       baseRoomPrice = singleRoomInfo?.room_price?.total_price || 0;
    //     }
    //   });

    //   const adultsCount = str === "child" ? noOfAdult : value;
    //   const rateAmount = selectedRoomPlan?.rate_amount || 0;
    //   const nights = calNoOfNights(range.startDate, range.endDate);

    //   setOriginalPrice(
    //     baseRoomPrice + rateAmount * adultsCount * nights
    //   );

    //   findRoomInfoAndSetPrice(roomInformationData.data, {
    //     discountMethod: discountType,
    //     discountValue: Number(discountValue),
    //   });
    // });
  }

  const elements: any = [];
  for (let i = 2; i <= noOfAdult; i++) {
    elements.push(
      <>
        <FormGroup>
          <Field
            name={`firstName${i}`}
            className="con-field p-1 rounded border focus:ring focus:border-blue-500"
            placeholder={`Enter First Name (extra ${i})`}
            type="text"
          />
          <p className="text-red-600">
            <ErrorMessage name={`firstName${i}`} />
          </p>
        </FormGroup>
        <FormGroup>
          <Field
            name={`lastName${i}`}
            className="con-field p-1 rounded border focus:ring focus:border-blue-500"
            placeholder={`Enter Last Name (extra ${i})`}
            type="text"
          />
          <p className="text-red-600">
            <ErrorMessage name={`lastName${i}`} />
          </p>
        </FormGroup>
      </>,
    );
  }

  const calculateMaxDiscount = () => {
    const serviceCharge =
      getRoomPrice(
        selectedRoomType.id || selectedRoomInfo?.room_type_id,
        roomTypeList1,
      ).service_charge || 0;
    const nights = calNoOfNights(range.startDate, range.endDate);
    const price = originalPrice;
    const roomServiceCharge = (price * serviceCharge) / 100;
    const priceWithService = price + roomServiceCharge;
    const taxRate = priceWithService / nights > 7500 ? 18 : 5;
    const tax = (priceWithService * taxRate) / 100;
    return priceWithService + tax;
  };

  if (calendarInfo) {
    return (
      <Formik
        initialValues={defaultValues}
        validationSchema={formValidation}
        onSubmit={(event) => handleSubmit(event)}
      >
        {({ values, setFieldValue }) => (
          <>
            {/* NEW: Duration + Room Type OUTSIDE */}
            <div className="booking-duration-wrapper">
              <div className="grid gap-4 lg:grid-cols-2 sm:grid-cols-2">
                <FormGroup>
                          <label htmlFor="">Duration</label>
                          <div className="con-field p-1 rounded border focus:ring focus:border-blue-500">
                            <DateRangeComponent
                              range={range}
                              onSetRange={(newRange: any) => {
                                if (
                                  moment(newRange.startDate).isSame(
                                    newRange.endDate,
                                    "day",
                                  )
                                ) {
                                  // If same day selected, set end date to next day
                                  newRange.endDate = moment(newRange.startDate)
                                    .add(1, "days")
                                    .toDate();
                                  const alertDiv = document.createElement("div");
                                  alertDiv.style.cssText = `
                          position: fixed;
                          top: 50%;
                          left: 50%;
                          transform: translate(-50%, -50%);
                          background: white;
                          color: #1976d2;
                          padding: 20px;
                          border-radius: 8px;
                          box-shadow: 0 4px 20px rgba(0,0,0,0.15);
                          z-index: 9999;
                          animation: slideIn 0.3s ease-out;
                          border: 2px solid white;
                          font-weight: 500;
                          min-width: 300px;
                          text-align: center;
                          `;

                                  alertDiv.innerHTML = `
                          <div style="margin-bottom: 15px;">
                          <svg width="40" height="40" viewBox="0 0 24 24" style="margin: 0 auto; display: block;">
                            <path fill="#1976d2" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                          </svg>
                          </div>
                          <div style="font-size: 16px;">
                          Same day bookings are not allowed.<br>End date has been set to next day.
                          </div>
                          <button style="
                          margin-top: 15px;
                          background: #1976d2;
                          color: white;
                          border: none;
                          padding: 8px 20px;
                          border-radius: 4px;
                          cursor: pointer;
                          font-weight: 500;
                          transition: background 0.2s;
                          " onclick="this.parentElement.remove()">
                          Understood
                          </button>
                          `;

                                  document.body.appendChild(alertDiv);

                                  // Add animation keyframes
                                  const style = document.createElement("style");
                                  style.textContent = `
                          @keyframes slideIn {
                          from { opacity: 0; transform: translate(-50%, -60%); }
                          to { opacity: 1; transform: translate(-50%, -50%); }
                          }
                          button:hover {
                          background: #1565c0 !important;
                          }
                          `;
                                  document.head.appendChild(style);

                                  setTimeout(() => {
                                    alertDiv.remove();
                                  }, 3000);
                                }
                                onSetRange(newRange);
                              }}
                              isShowPastDate={false}
                              startFalse={true}
                              minDuration={1}
                            />
                          </div>
                        </FormGroup>

                <FormGroup>
                          <label htmlFor="">Room Type</label>
                          <Field
                            as="select"
                            type="number"
                            name="roomType"
                            onChange={(e: any) => {
                              onRoomTypeSelected(e.target.value);
                              setFieldValue("rateType", "");
                            }}
                            value={selectedRoomType.id}
                            style={{
                              color: selectedRoomType.id ? "#0001ff" : "black",
                              fontWeight: selectedRoomType.id ? "600" : "400",
                            }}
                          >
                            <option value="">select</option>
                            {roomTypeList.map((roomType: any, key: any) => (
                              <option
                                value={roomType.id}
                                key={key}
                                style={{
                                  backgroundColor:
                                    selectedRoomType.id === roomType.id
                                      ? "#e3f2fd"
                                      : "white",
                                  color:
                                    selectedRoomType.id === roomType.id
                                      ? "#1976d2"
                                      : "black",
                                }}
                              >
                                {roomType.room_type_name}
                              </option>
                            ))}
                          </Field>
                          <p className="text-red-600">
                            <ErrorMessage name="roomType" />
                          </p>
                        </FormGroup>
              </div>
            </div>
    
          <div className="booking-form-wrapper">
            {/* <div className="grid gap-4 lg:grid-cols-2 sm:grid-cols-2">
              <div style={{ flex: 1 }}>
                <p>Duration:</p>
                <DateRangeComponent
                  range={range}
                  onSetRange={onSetRange}
                  isShowPastDate={false}
                  startFalse={true}
                />
              </div>
              <div style={{ flex: 1, textAlign: "right" }}>
                <p style={{ marginBottom: 0 }}>
                  Room Type:{" "}
                  <span style={{ color: "blue", fontWeight: "bold" }}>
                    {selectedRoomInfo?.room_type_name}
                  </span>
                </p>
              </div>
            </div> */}
            {/* <Formik
              initialValues={defaultValues}
              validationSchema={formValidation}
              onSubmit={(event) => handleSubmit(event)}
            >
              {({ values, setFieldValue }) => ( */}
            <Form className="grid lg:grid-cols-1 p-8">
              <div className="grid gap-4 lg:grid-cols-2 sm:grid-cols-2">
                <FormGroup>
                  <label htmlFor="">
                    Rate Type <span style={{ color: "red" }}>*</span>
                  </label>
                  <Field
                    as="select"
                    name="rateType"
                    onChange={(e: any) => {
                      handleOnchangePlan(e.target.value);
                      setRateType(e.target.value);
                      setFieldValue("rateType", e.target.value);
                    }}
                    value={rateType}
                  >
                    <option value="">Select</option>
                    {roomRatePlan?.map((plan: any) => (
                      <option value={plan?.name} key={plan?.id}>
                        {plan?.name}
                      </option>
                    ))}
                  </Field>
                  <p className="text-red-600">
                    <ErrorMessage name="rateType" />
                  </p>
                </FormGroup>

                <FormGroup>
                  <label htmlFor="">Room No</label>
                  <Field
                    as="select"
                    name="room"
                    value={selectedRoom.id || ""}
                    onChange={(e: any) => {
                      onRoomSelected(e.target.value);
                      setFieldValue("room", e.target.value);
                    }}
                  >
                    <option value={""}>select</option>
                    {emptyRoom.map((room: any, key: any) => (
                      <option value={room.id} key={key}>
                        {room.room_name}
                      </option>
                    ))}
                  </Field>
                  <p className="text-red-600">
                    <ErrorMessage name="room" />
                  </p>
                </FormGroup>
              </div>

              <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-2">
                <div className="form-group">
                  <label htmlFor="adult" className=" font-semibold">
                    Adult
                  </label>
                  <div className="relative">
                    <select
                      name="adult"
                      onChange={(e) => onNoOfAdultlChange(e.target.value)}
                      value={noOfAdult}
                      className="w-full border rounded-md p-1 focus:outline-none focus:ring-1 focus:border-sky-200 appearance-none transition-transform transform-gpu hover:scale-105"
                    >
                      <option value="">Select</option>
                      {(() => {
                        const selectedType =
                          roomTypeList1?.find?.(
                            (r: any) => r.id === selectedRoomType.id,
                          ) ||
                          roomTypeList?.find?.(
                            (r: any) => r.id === selectedRoomType.id,
                          );
                        const maxOccupancy =
                          selectedType?.higher_occupancy ||
                          selectedType?.base_occupancy ||
                          1;
                        return Array.from({ length: maxOccupancy }, (_, i) => (
                          <option key={i + 1} value={i + 1}>
                            {i + 1}
                          </option>
                        ));
                      })()}
                    </select>
                    <p className="text-red-600">
                      <ErrorMessage name="adult" />
                    </p>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="child" className=" font-semibold">
                    Child
                  </label>
                  <div className="relative">
                    <select
                      name="child"
                      onChange={(e) =>
                        onNoOfAdultlChange(e.target.value, "child")
                      }
                      value={noOfChild}
                      className="w-full border rounded-md p-1 focus:outline-none focus:ring-1 focus:border-sky-200 appearance-none"
                    >
                      <option value="0">0</option>
                      <option value={1}>1</option>
                      <option value={2}>2</option>
                      <option value={3}>3</option>
                    </select>
                    <p className="text-red-600">
                      <ErrorMessage name="child" />
                    </p>
                  </div>
                </div>
                {/* <div className="form-group">
                  <label htmlFor="rooms" className=" font-semibold">
                    Rooms
                  </label>
                  <div className="relative">
                    <select
                      name="rooms"
                      className="w-full border rounded-md p-1 focus:outline-none focus:ring-1 focus:border-sky-200 appearance-none"
                      value={noOfRoomsSelected}
                      onChange={handleRoomChanged}
                    >
                      {Array.from({ length: noOfRoomsAvl }, (_, i) => (
                        <option key={i} value={i + 1}>
                          {i + 1}
                        </option>
                      ))}
                    </select>
                    <p className="text-red-600">
                      <ErrorMessage name="rooms" />
                    </p>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                          {i + 1}
                        </option>
                      ))}
                    </select>
                    <p className="text-red-600">
                      <ErrorMessage name="rooms" />
                    </p>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div> */}
              </div>

              <div className="grid gap-4 lg:grid-cols-2 sm:grid-cols-2">
                <FormGroup>
                  <label htmlFor="">
                    First Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <Field
                    name="firstName"
                    className="con-field p-1 rounded border focus:ring focus:border-blue-500"
                    placeholder="Enter First Name"
                    type="text"
                  />
                  <p className="text-red-600">
                    <ErrorMessage name="firstName" />
                  </p>
                </FormGroup>
                <FormGroup>
                  <label htmlFor="">Last Name</label>
                  <Field
                    name="lastName"
                    className="con-field p-1 rounded border focus:ring focus:border-blue-500"
                    placeholder="Enter Last Name"
                    type="text"
                  />
                  <p className="text-red-600">
                    <ErrorMessage name="lastName" />
                  </p>
                </FormGroup>
              </div>

              <div className="grid gap-4 lg:grid-cols-2 sm:grid-cols-2 ">
                <FormGroup>
                  <label htmlFor="">
                    Email <span style={{ color: "red" }}>*</span>
                  </label>
                  <Field
                    name="email"
                    className="con-field"
                    placeholder="Enter Email id"
                    id="email"
                    type="text"
                  />
                  <p className="text-red-600">
                    <ErrorMessage name="email" />
                  </p>
                </FormGroup>
                <FormGroup>
                  <label htmlFor="">
                    Mobile <span style={{ color: "red" }}>*</span>
                  </label>
                  <Field
                    name="mobNumber"
                    className="con-field"
                    placeholder="Enter Mobile no*"
                    id="mobNumber"
                    type="text"
                  />
                  <p className="text-red-600">
                    <ErrorMessage name="mobNumber" />
                  </p>
                </FormGroup>
              </div>

              <FormGroup>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    marginBottom: "9px",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={useReversePrice}
                    onChange={(e) => handleReversePriceToggle(e.target.checked)}
                  />
                  <span>Prices Include Tax</span>
                </label>
              </FormGroup>

              <div className="grid gap-4 lg:grid-cols-2">
                <FormGroup>
                  <label htmlFor="">
                    Price (Base){" "}
                    <span style={{ fontSize: "13px" }}>
                      (
                      {calNoOfNights(range.startDate, range.endDate) > 1
                        ? `${calNoOfNights(
                            range.startDate,
                            range.endDate,
                          )} nights`
                        : `${calNoOfNights(
                            range.startDate,
                            range.endDate,
                          )} night`}
                      )
                    </span>
                  </label>
                  <Field
                    name="price_1"
                    className="con-field"
                    placeholder="Enter Base Price*"
                    id="price_1"
                    readOnly={useReversePrice}
                    disabled={useReversePrice}
                    onChange={(e: any) => {
                      if (useReversePrice) return;
                      setOriginalPrice(+e.target.value);
                    }}
                    value={originalPrice}
                    type="number"
                  />
                </FormGroup>

                <FormGroup>
                  <label htmlFor="">
                    Final Price{" "}
                    <span style={{ fontWeight: "normal", fontSize: "10px" }}>
                      (Incl. tax & svc. charge)
                    </span>
                  </label>
                  <Field
                    name="price"
                    className="con-field"
                    placeholder="Enter Final Price*"
                    id="price"
                    readOnly={!useReversePrice}
                    disabled={!useReversePrice}
                    onChange={(e: any) => {
                      if (!useReversePrice) return;
                      applyReversePriceCalc(+e.target.value);
                    }}
                    value={calculatedPrice.total_price_with_tax}
                    type="number"
                  />
                </FormGroup>

                {/* <FormGroup>
                  <label htmlFor="">
                    Payment Mode
                  </label>
                  <Field
                    as="select"
                    name="payment_mode"
                    value={paymentMode}
                    onChange={(e: any) => setPaymentMode(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="Direct">Direct</option>
                    <option value={"Bill to company"}>Bill to company</option>
                  </Field>

                  <p className="text-red-600">
                    <ErrorMessage name="Type" />
                  </p>
                </FormGroup> */}
              </div>

              <div className="grid gap-4 lg:grid-cols-2 mt-6">
                <FormGroup>
                  <Button
                    type="submit"
                    onClick={(e) => handleReserveSubmit(e)}
                    name="reserve"
                    className="bg-sky-300 hover:bg-sky-400"
                  >
                    Reserve
                  </Button>
                </FormGroup>
                {isEqualOrAfter(moment().startOf("day"), calendarInfo.start) ? (
                  <FormGroup>
                    <Button
                      type="submit"
                      name="checkIn"
                      className="bg-sky-300 hover:bg-sky-400"
                    >
                      Check In
                    </Button>
                  </FormGroup>
                ) : (
                  <></>
                )}
              </div>
            </Form>
          </div>
          </>
          )}
      </Formik>      
    );
  } else {
    return <p>Sorry something wrong</p>;
  }
};

export default ReservationFrom;
